import styled from "styled-components";

export const PaginationContent = styled.div``;
